/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SentEmail } from './SentEmail';
import {
    SentEmailFromJSON,
    SentEmailFromJSONTyped,
    SentEmailToJSON,
    SentEmailToJSONTyped,
} from './SentEmail';

/**
 * 
 * @export
 * @interface EmployeeInvite
 */
export interface EmployeeInvite {
    /**
     * 
     * @type {string}
     * @memberof EmployeeInvite
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof EmployeeInvite
     */
    companyId: number;
    /**
     * The id of the employee the invite was sent to.
     * @type {number}
     * @memberof EmployeeInvite
     */
    employeeId: number;
    /**
     * The id of the employee who sent the invite.
     * @type {number}
     * @memberof EmployeeInvite
     */
    invitedById: number;
    /**
     * 
     * @type {SentEmail}
     * @memberof EmployeeInvite
     */
    sentEmail: SentEmail;
    /**
     * 
     * @type {Date}
     * @memberof EmployeeInvite
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof EmployeeInvite
     */
    updatedAt: Date | null;
}

/**
 * Check if a given object implements the EmployeeInvite interface.
 */
export function instanceOfEmployeeInvite(value: object): value is EmployeeInvite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('invitedById' in value) || value['invitedById'] === undefined) return false;
    if (!('sentEmail' in value) || value['sentEmail'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function EmployeeInviteFromJSON(json: any): EmployeeInvite {
    return EmployeeInviteFromJSONTyped(json, false);
}

export function EmployeeInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeInvite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'employeeId': json['employeeId'],
        'invitedById': json['invitedById'],
        'sentEmail': SentEmailFromJSON(json['sentEmail']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (json['updatedAt'] == null ? null : new Date(json['updatedAt'])),
    };
}

  export function EmployeeInviteToJSON(json: any): EmployeeInvite {
      return EmployeeInviteToJSONTyped(json, false);
  }

  export function EmployeeInviteToJSONTyped(value?: EmployeeInvite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyId': value['companyId'],
        'employeeId': value['employeeId'],
        'invitedById': value['invitedById'],
        'sentEmail': SentEmailToJSON(value['sentEmail']),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': (value['updatedAt'] == null ? null : (value['updatedAt'] as any).toISOString()),
    };
}

